const quizElement = document.querySelector( '.wpProQuiz_content' );
// First check if we're in a quiz page, and then if that quiz page is equal to 349 which is the Driving Forces quiz that we want to execute everything
if ( quizElement ) {
	const dfQuizIds = [ 349, 6760 ];
	const quizAttributes = quizElement.dataset.quizMeta;
	const quizObj = JSON.parse( quizAttributes );
	const quizID = quizObj.quiz_post_id;

	if ( dfQuizIds.includes( quizID ) ) {
		addResultsObserver();
	}
}

// Add observer on the default Learndash results element to check for its style change and then begin building the bar chart
function addResultsObserver() {
	const resultsWrapper = document.querySelector( '.wpProQuiz_results' );

	const config = { attributes: true, childList: true, subtree: true };

	// Callback function to execute when mutations are observed
	const callback = function( mutationsList ) {
		// Use traditional 'for loops' for IE 11
		for ( const mutation of mutationsList ) {
			if ( mutation.type === 'attributes' ) {
				if ( mutation.attributeName === 'style' ) {
					const targetComputedStyles = getComputedStyle( mutation.target );
					const isTargetDisplayNone = targetComputedStyles.getPropertyValue( 'display' ) === 'none';

					if ( mutation.target === resultsWrapper && ! isTargetDisplayNone ) {
						buildBarChart();
					}
				}
			}
		}
	};

	// Create an observer instance linked to the callback function
	const observer = new MutationObserver( callback );

	// Start observing the target node for configured mutations
	observer.observe( resultsWrapper, config );

	// Later, you can stop observing
	// observer.disconnect();
}

// Begin building the bar chart
// Loop through all quiz inputs and find the ones that are checked and have a rank letter to build an array with all the answers
function buildBarChart() {
	const inputPoints = [];
	const quizInputs = document.querySelectorAll( '.wpProQuiz_questionListItem label' );

	let inputText = '';
	let checkedInput = '';

	quizInputs.forEach( input => {
		checkedInput = input.querySelector( '.wpProQuiz_questionInput' );
		inputText = input.textContent;
		if ( checkedInput.checked ) {
			const questionRank = inputText.substring(
				inputText.indexOf( '[' ) + 1,
				inputText.lastIndexOf( ']' )
			);

			if ( questionRank !== '' ) {
				const ranking = [];
				ranking.letter = questionRank;
				ranking.points = 0;
				inputPoints.push( ranking );
			}
		}
	} );

	calculatePointsPerLetter( inputPoints );
}

// Loop through the array that contains all points to create an array with the unique letter type rankings (X,W,V,Y,Z) along with all the points for each letter
function calculatePointsPerLetter( pointsArray ) {
	const pointsArrayLength = pointsArray.length;

	const uniqueObjArray = [ ...new Map( pointsArray.map( item => [ item.letter, item ] ) ).values() ];

	const ranksArrayLength = uniqueObjArray.length;
	for ( let i = 0; i < pointsArrayLength; i++ ) {
		const currentPoint = pointsArray[ i ].letter;

		for ( let j = 0; j < ranksArrayLength; j++ ) {
			const currentLetter = uniqueObjArray[ j ].letter;

			if ( currentLetter === currentPoint ) {
				uniqueObjArray[ j ].points++;
			}
		}
	}

	setBarWidth( uniqueObjArray );
}

// Set the width and a separate class for each rank element on the chart depending on the total answers given by the users.
function setBarWidth( totalPoints ) {
	const totalLength = totalPoints.length;
	for ( let i = 0; i < totalLength; i++ ) {
		const letterRank = totalPoints[ i ].letter;
		const rankPoints = totalPoints[ i ].points;
		const element = document.querySelector( '.bar-chart-progress-row[data-progress-bar-id="' + letterRank + '"]' );
		const progressBar = element.querySelector( '.progress-width' );

		const barWidth = document.querySelector( '.bar-chart-progress-rows' ).offsetWidth;

		const widthSteps = document.querySelectorAll( '.bar-chart-step-column' ).length - 1;
		const progressWidth = ( ( barWidth / widthSteps ) * rankPoints ) - rankPoints;
		progressBar.style.width = progressWidth + 'px';

		const configuration = {
			'progress-level-1': 3,
			'progress-level-2': 6,
			'progress-level-3': 9,
			'progress-level-4': 12,
		};

		let className = '';

		for ( const classArray of Object.entries( configuration ) ) {
			const [ thresholdClass, pointThreshold ] = classArray;

			if ( rankPoints <= pointThreshold ) {
				className = thresholdClass;
				break;
			}
		}

		progressBar.classList.add( className );
	}
}
